export const formatDateToFrenshFormat = (
  d: string | Date,
  includeTime: boolean = false
): string => {
  if (!d) return "";

  console.log(d);
  const date = typeof d === "string" ? new Date(d) : d;

  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let result = `${day}/${month}/${year}`;

  if (includeTime) {
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    result += ` ${hours}:${minutes}`;
  }

  return result;
};
